export default __webpack_public_path__ + "static/media/CarImages.SorentoGallery6.cb6ead4f.jpg";